<template>
  <section class="section">
    <div class="container">
      <h2 class="section-title">支持的框架与模型</h2>
      <p class="section-lead">全面兼容主流深度学习生态</p>
      <div class="frameworks-grid">
        <div v-for="f in frameworks" :key="f.title" class="framework-card">
          <div class="framework-tag"></div>
          <h3>{{ f.title }}</h3>
          <p>{{ f.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const frameworks = [
  { title: 'PyTorch', desc: '完整 PyTorch 生态支持，包括 torchvision、torchaudio、PyTorch Lightning' },
  { title: 'TensorFlow', desc: 'TensorFlow 2.x 全版本支持，Keras 高级 API 集成' },
  { title: 'JAX', desc: 'JAX + Flax 支持，适用于研究级模型开发' },
  { title: 'DeepSpeed', desc: 'ZeRO 优化器集成，支持 ZeRO-1/2/3 分布式策略' },
  { title: 'Megatron-LM', desc: '大规模语言模型训练框架，支持张量并行与流水线并行' },
  { title: 'HuggingFace', desc: 'Transformers 库完整支持，预训练模型即取即用' },
  { title: 'vLLM', desc: '高性能大语言模型推理引擎，PagedAttention 优化' },
  { title: 'TensorRT', desc: 'NVIDIA 推理优化引擎，低延迟高吞吐部署' }
];
</script>

<style scoped>
.section-lead {
  text-align: center;
  color: var(--fg-secondary);
  max-width: 700px;
  margin: 0 auto;
}
</style>
